import { XML_ConvertDPI } from "./XML_ConvertDPI";
import { XML_GetDX } from "./XML_GetDX";
import { XML_GetScale } from "./XML_GetScale";

export function XML_ScaleAndShiftX(x, drawElement, layer) {
  x = XML_ConvertDPI(x);

  var scale = XML_GetScale(drawElement, layer); // drawElement["scale"];
  if (scale != null) x *= scale;

  var dx = XML_GetDX(drawElement, layer); //drawElement["dx"];
  if (dx != null) x += dx;

  //	x = RoundTo3(x)
  return x;
}
